module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }, [(_vm.iShow) ? _c('div', [_c('div', {
    staticClass: "toast-mask",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": function($event) {
        return _vm.showToast(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toast-body"
  }, [_vm._m(0), _vm._v(" "), _c('pre', {
    staticClass: "toast-msg"
  }, [_vm._v(_vm._s(_vm.configData.marketRule))])])]) : _vm._e(), _vm._v(" "), (_vm.configType && !_vm.showTreatmentList) ? [_c('div', {
    staticClass: "wrap"
  }, [_c('section', {
    staticClass: "activity-bg",
    style: ({
      backgroundImage: 'url(\'' + _vm.configData.backgroundImage + '\')'
    })
  }, [_c('div', {
    staticClass: "content-topbox"
  }, [_c('img', {
    staticClass: "content-logimg",
    attrs: {
      "src": _vm.configData.logoImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-bottbox"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.configData.envelopeImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-val"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postData.phoneNum),
      expression: "postData.phoneNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请正确填写手机号"
    },
    domProps: {
      "value": (_vm.postData.phoneNum)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getFocus($event)
      },
      "blur": _vm.fixWindow,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.postData, "phoneNum", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postData.verifyCode),
      expression: "postData.verifyCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.postData.verifyCode)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getFocus($event)
      },
      "blur": _vm.fixWindow,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.postData, "verifyCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-get-code msg",
    on: {
      "click": function($event) {
        return _vm.getImgCode()
      }
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('p', {
    staticClass: "content-button",
    style: ({
      overflow: 'hidden',
      height: '17.5vw',
      backgroundImage: 'url(' + _vm.configData.buttonImage + ')',
      backgroundSize: 'contain',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat'
    }),
    on: {
      "click": function($event) {
        return _vm.receiveGifts()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content-introduce",
    on: {
      "click": function($event) {
        return _vm.showToast(true)
      }
    }
  }, [_vm._v("活动规则")])])])])])] : _vm._e(), _vm._v(" "), (_vm.showTreatmentList) ? _c('div', {
    staticClass: "treatment-list"
  }, [(_vm.configType) ? _c('div', {
    staticClass: "wrap"
  }, [_c('section', {
    staticClass: "activity-bg",
    style: ({
      backgroundImage: 'url(\'' + _vm.configData.backgroundImage + '\')'
    })
  }, [_c('div', {
    staticClass: "content-topbox"
  }, [_c('share', {
    attrs: {
      "title": _vm.configData.subTitle,
      "desc": _vm.configData.shareUrlTitle,
      "imgUrl": _vm.configData.shareUrlImage,
      "link": _vm.link
    }
  }), _vm._v(" "), (_vm.configData.sort != 3) ? _c('img', {
    staticClass: "content-logimg",
    staticStyle: {
      "max-height": "70px"
    },
    attrs: {
      "src": _vm.configData.logoImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configData.sort == 3) ? _c('img', {
    staticClass: "content-logimg",
    attrs: {
      "src": _vm.configData.successSubTitle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configData.sort != 3) ? _c('div', {
    staticClass: "envelope-prompt"
  }, [_c('p', [_vm._v(_vm._s(_vm.isLogin ? "已成功领取" : "领取成功"))]), _vm._v(" "), _c('span', [_vm._v("优惠券已放入" + _vm._s(_vm.upPhoneNum(_vm.phone)) + "的会员账户")])]) : _vm._e(), _vm._v(" "), (_vm.configData.sort == 3) ? _c('div', {
    staticClass: "envelope-prompt"
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("专属百元礼包已放入您的亚朵账户")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-bottbox",
    style: (_vm.configData.marketValue == 1 ? '' : (_vm.configData.envelopeImage ? ('background: url(' + _vm.configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : ''))
  }, [_c('ul', {
    staticClass: "list-css",
    class: _vm.configData.marketValue == 1 ? 'newbac-css' : 'bac-css',
    style: (_vm.configData.sort == 3 ? 'bottom: 16%;' : ''),
    attrs: {
      "tabindex": "-1"
    }
  }, _vm._l((_vm.couponList), function(item) {
    return _c('li', {
      staticClass: "clearfix content-img",
      style: (_vm.configData.successSubTitle ? ('background: url(' + _vm.configData.successSubTitle + ') no-repeat;background-size: 100% 100%;') : '')
    }, [_c('div', {
      staticClass: "fl price clearfix",
      style: (_vm.configData.successTitle ? ('background: url(' + _vm.configData.successTitle + ') no-repeat;background-size: 100% 100%;') : '')
    }, [_c('p', {}, [_vm._v(_vm._s(item.value) + "元")])]), _vm._v(" "), _c('div', {
      staticClass: "fr content-fr"
    }, [_c('p', {
      staticClass: "count"
    }, [_vm._v(_vm._s(item.disTypeName))]), _vm._v(" "), _c('p', {
      staticClass: "count",
      staticStyle: {
        "color": "#FB3653"
      }
    }, [_vm._v("x" + _vm._s(item.count ? item.count : 1))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bacbottom-img"
  }, [(_vm.configData.buttonUrlType === 1) ? _c('div', {
    staticClass: "dow-title",
    on: {
      "click": _vm.useAction
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configData.buttonUrlType === 2) ? _c('div', {
    staticClass: "look-button",
    on: {
      "click": _vm.lookTicket
    }
  }, [_vm._v("去查看")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "content-introduce",
    staticStyle: {
      "position": "absolute",
      "width": "6em",
      "text-align": "center",
      "left": "50%",
      "bottom": "0",
      "margin-left": "-3em"
    },
    on: {
      "click": function($event) {
        return _vm.showToast(true)
      }
    }
  }, [_vm._v("活动规则")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('img-code', {
    attrs: {
      "show": _vm.isShow,
      "phone": _vm.postData.phoneNum,
      "codeType": _vm.codeType
    },
    on: {
      "showOff": _vm.showOff
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "toast-title"
  }, [_vm._v("活动介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "size-color"
  }, [_vm._v("恭喜您\n                                "), _c('br'), _vm._v("成为亚朵金卡会员")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02750f7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/treatment.vue
// module id = 153
// module chunks = 2